"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUsageLegacyQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var core_1 = require("../../../core");
var utils_1 = require("./utils");
function useUsageLegacyQuery(accountId, date, datePeriod, isDisabled) {
    var api = core_1.configService.getConfig().api;
    var halfHourlyUsageEndpoint = (0, utils_1.createHalfHourlyUsageEndpoint)(accountId, (0, date_fns_1.format)(date, 'yyyy-MM-dd'));
    var dailyUsageEndpoint = (0, utils_1.createDailyUsageEndpoint)(accountId, (0, date_fns_1.format)(date, 'yyyy-MM'));
    var monthlyUsageEndpoint = (0, utils_1.createMonthlyUsageEndpoint)(accountId, (0, date_fns_1.format)(date, 'yyyy'));
    return (0, ui_tools_1.useReactQuery)("cx-usage-".concat(datePeriod, "-").concat(accountId, "-").concat(date), function () {
        if (datePeriod === 'daily') {
            return core_1.apiService
                .get({
                url: "".concat(api.baseUrl).concat(halfHourlyUsageEndpoint),
                headers: { Accept: 'application/json;version=2' },
            })
                .then(utils_1.formatDailyUsageGeneric);
        }
        else if (datePeriod === 'monthly') {
            return core_1.apiService
                .get({
                url: "".concat(api.baseUrl).concat(dailyUsageEndpoint),
                headers: { Accept: 'application/json;version=2' },
            })
                .then(utils_1.formatMonthlyUsageGeneric);
        }
        else {
            return core_1.apiService
                .get({
                url: "".concat(api.baseUrl).concat(monthlyUsageEndpoint),
                headers: { Accept: 'application/json;version=2' },
            })
                .then(utils_1.formatYearlyUsageGeneric);
        }
    }, {
        staleTime: 300000,
        cacheTime: 300000,
        enabled: !isDisabled,
    });
}
exports.useUsageLegacyQuery = useUsageLegacyQuery;
